// import { Snackbar, Alert } from "@mui/material";

// export default function Notification({ success, text, open, onClose }) {
//   return (
//     <Snackbar
//       open={open}
//       autoHideDuration={4000}
//       onClose={onClose}
//       anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//     >
//       <Alert
//         onClose={onClose}
//         severity={success ? "success" : "error"}
//         variant="filled"
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           borderRadius: "8px",
//           fontWeight: "bold",
//           fontSize: "0.95rem",
//           boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
//         }}
//       >
//         {text}
//       </Alert>
//     </Snackbar>
//   );
// }


import { Snackbar, Alert } from "@mui/material";

export default function Notification({ success, text, open, onClose }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={success ? "success" : "error"}
        variant="filled"
        iconMapping={{
          success: (
            <img
              src="/icons/Checkmark Icon.svg"   // 🔥 your custom tick icon
              alt="success"
              style={{ width: 20, height: 20 }}
            />
          ),
        }}
        sx={{
          backgroundColor: success ? "#016100" : "#D32F2F",
          display: "flex",
          alignItems: "center",
          borderRadius: "8px",
          fontWeight: "400",
          fontSize: "0.75rem",
          fontFamily: "Akkurat",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        {text}
      </Alert>
    </Snackbar>
  );
}